// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".legend {\n    background: #f2f2f2 !important;\n    margin-bottom: 15px;\n}", "",{"version":3,"sources":["webpack://src/components/Admin/Applications/index.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,mBAAmB;AACvB","sourcesContent":[".legend {\n    background: #f2f2f2 !important;\n    margin-bottom: 15px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
